export default {
  myMakes: state => state.myMakes,
  competitorMakes: state => state.competitorMakes,
  makes: state => state.makes,
  primaryDaysInStockBreakdown: state => state.primaryDaysInStockBreakdown,
  competitorDaysInStockBreakdown: state => state.competitorDaysInStockBreakdown,
  primaryPercentBreakdown: state => state.primaryPercentBreakdown,
  competitorPercentBreakdown: state => state.competitorPercentBreakdown,
  primaryMarketDemandBreakdown: state => state.primaryMarketDemandBreakdown,
  competitorMarketDemandBreakdown: state =>
    state.competitorMarketDemandBreakdown,
  primaryModelBreakdown: state => state.primaryModelBreakdown,
  competitorModelBreakdown: state => state.competitorModelBreakdown,
  primaryDealerTypeBreakdown: state => state.primaryDealerTypeBreakdown,
  competitorDealerTypeBreakdown: state => state.competitorDealerTypeBreakdown,
  primaryNearlyNewBreakdown: state => state.primaryNearlyNewBreakdown,
  competitorNearlyNewBreakdown: state => state.competitorNearlyNewBreakdown
}
